export enum FailureType {
    DirectLineResponse,
    BotNoRespondTimeout,
    DirectLineConnectionRejected,
    CreateDirectLine,
    ReactWebChatComponent,
    BotMessageTimeout,
    UnhandledExceptionOccurredInBot,
}
